import { CertificateNavigationItem } from '@app/layout/sidebar/models/certificate-navigation-item.model'
import { enumValueFromRaw, OBJECT_TYPE, OBJECT_TYPE_OPTIONS, ObjectType } from '@features/certificate/models/certificate-select-options.model'

export type CertificateRow =
  /** `uuids` are the certificates of this subsection, so it can be selected as a whole. */
  | { kind: 'header', label: string, uuids: string[] }
  | { kind: 'certificate', item: CertificateNavigationItem | undefined }

const OBJECT_TYPE_ORDER: readonly ObjectType[] = OBJECT_TYPE_OPTIONS

export function groupCertificatesByObjectType(items: readonly (CertificateNavigationItem | undefined)[]): CertificateRow[] {
  const grouped = new Map<ObjectType, CertificateNavigationItem[]>()
  const ungrouped: (CertificateNavigationItem | undefined)[] = []

  items.forEach(item => {
    const objectType = item === undefined ? null : enumValueFromRaw(OBJECT_TYPE, item.certificateObjectType)
    if (item === undefined || objectType === null || !OBJECT_TYPE_ORDER.includes(objectType)) {
      ungrouped.push(item)
      return
    }
    const group = grouped.get(objectType) ?? []
    group.push(item)
    grouped.set(objectType, group)
  })

  const rows: CertificateRow[] = []
  OBJECT_TYPE_ORDER.forEach(objectType => {
    const group = grouped.get(objectType)
    if (group === undefined || group.length === 0) {
      return
    }
    rows.push({ kind: 'header', label: objectType, uuids: group.map(item => item.uuid) })
    group.forEach(item => rows.push({ kind: 'certificate', item }))
  })
  ungrouped.forEach(item => rows.push({ kind: 'certificate', item }))

  return rows
}

export function toCertificateRows(items: readonly (CertificateNavigationItem | undefined)[]): CertificateRow[] {
  return items.map(item => ({ kind: 'certificate', item }))
}

export function certificateIndexOfRow(rows: readonly CertificateRow[], rowIndex: number): number {
  let index = -1
  for (let i = 0; i <= rowIndex && i < rows.length; i++) {
    if (rows[i]?.kind === 'certificate') {
      index++
    }
  }
  return Math.max(index, 0)
}
